import axios from "axios";

const mainAxios = axios.create({
    // baseURL: "https://ean-unplaced-shanna.ngrok-free.dev/",
    baseURL: "http://server.voyasiadmc.com/",
    // baseURL: "http://192.168.1.39:3002/",
    // baseURL: "http://15.207.243.133:3001/",
});

export { mainAxios };
